import * as type from "../types";

export function getAllContractsRequested(reqParams) {
  return {
    type: type.GET_ALL_CONTRACTS_REQUESTED,
    payload: reqParams,
  };
}
export function getAllContractsSucceeded(data) {
  return {
    type: type.GET_ALL_CONTRACTS_SUCCEEDED,
    payload: data,
  };
}
export function getAllContractsFailed() {
  return {
    type: type.GET_ALL_CONTRACTS_FAILED,
  };
}
export function setContractFilter(data) {
  return {
    type: type.SET_CONTRACT_FILTER,
    payload: data,
  };
}
export function setCurrentContracts(data) {
  return {
    type: type.SET_CURRENT_CONTRACTS,
    payload: data,
  };
}
export function setCurrentContractSelected(data) {
  return {
    type: type.SET_CURRENT_CONTRACT_SELECTED,
    payload: data,
  };
}
export function setAllContractSelected(data) {
  return {
    type: type.SET_ALL_CONTRACT_SELECTED,
    payload: data,
  };
}
